<template>
  <div class="tag-input">
    <div
      v-for="(tag,index) in tags"
      :key="tag"
      class="tag-input__tag"
    >
      {{ tag }}
      <span @click="removeTag(index)">x</span>
    </div>
    <base-autocomplete
      class="d-inline-block tag-auto-complete"
      id="groupTag"
      v-model="inputValue"
      :items="autoCompleteOptions"
      :autoclear="true"
      @change="addTag"
      @submit="addTag"
    />
  </div>
</template>
<script>
import BaseAutocomplete from '@/components/form/BaseAutocomplete.vue';

export default {
  name: 'TagInput',
  components: { BaseAutocomplete },
  props: {
    options: {
      type: Array,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      inputValue: '',
    //   tags: [],
    };
  },
  computed: {
    autoCompleteOptions() {
      return this.options
        .map((item) => ({
          name: item,
          value: item,
        }));
    },
  },
  methods: {
    addTag() {
      const val = this.inputValue.trim();
      if (val.length > 0) {
        this.tags.push(val);
        this.inputValue = '';
        this.$emit('change', this.tags);
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    removeLastTag(event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1);
      }
    },
  },
};
</script>
<style scoped>
  .tag-input {
    width: 100%;
    border: 1px solid #eee;
    font-size: 0.9em;
    height: 50px;
    box-sizing: border-box;
    padding: 0 10px;
  }
  .tag-auto-complete{
    min-width: 30%;
    margin-top: 5px;
  }

  .tag-input__tag {
    height: 30px;
    float: left;
    margin-right: 10px;
    background-color: #eee;
    margin-top: 10px;
    line-height: 30px;
    padding: 0 5px;
    border-radius: 5px;
  }

  .tag-input__tag > span {
    cursor: pointer;
    opacity: 0.75;
  }

  .tag-input__text {
    border: none;
    outline: none;
    font-size: 0.9em;
    line-height: 50px;
    background: none;
  }
</style>
